const config = {
  root: null,
  rootMargin: '0px',
  threshold: 0
};

let previousY = 0;
let previousRatio = 0;



const animationItems = document.querySelectorAll('.animation');

let observer = new IntersectionObserver(function(entries) {

  entries.forEach(entry => {
    const currentY = entry.boundingClientRect.y
    const currentRatio = entry.intersectionRatio
    const isIntersecting = entry.isIntersecting
    const element = entry.target;


    if (isIntersecting) {
      element.classList.remove('outview');
      element.classList.add('inview');
      element.classList.add('has-been-animated');
    } else {
      element.classList.remove('inview');
      element.classList.add('outview');
    }
     // observer.unobserve(element);




    element.classList.remove("outview-top", "inview-top", "inview-bottom", "outview-bottom");
    // Scrolling up
    if (currentY < previousY) {
      const className = (currentRatio >= previousRatio) ? "inview-top" : "outview-top";
      element.classList.add(className);

      // Scrolling down
    } else if (currentY > previousY) {
      const className = (currentRatio <= previousRatio) ? "outview-bottom" : "inview-bottom";
      element.classList.add(className);
    }

    previousY = currentY
    previousRatio = currentRatio
  })
}, config);





animationItems.forEach(aItem => {
  observer.observe(aItem);
});
